/** Officer-facing labels for seed-resolve `sources[]` (never show raw API tokens). */

const SOURCE_LABELS: Record<string, string> = {
    instagram_harvest: "Already in this case's Instagram extract",
    p2p: 'P2P ad profile link',
    mulehunter: 'MuleHunter harvest',
    officer_supplied: "That's already a username",
};

export function labelSeedSource(source: string): string {
    const key = (source || '').trim();
    return SOURCE_LABELS[key] || key.replace(/_/g, ' ');
}

export function labelSeedSources(sources: string[]): string {
    return sources.map(labelSeedSource).join(' · ');
}
